import BaseRepository from '@/api/repositories/BaseRepository';

class LawyerOfficeApplicationRepository extends BaseRepository {
	get endpoint() {
		return 'api/lawyer_office_applications';
	}

	applyToRepairShop(lawyerOfficeApplicationId, lawyerOffice) {
		return this.put(`${lawyerOfficeApplicationId}/apply_to_repair_shop`, {}, { lawyerOffice });
	}
}

export default new LawyerOfficeApplicationRepository();
